import { IconButton, Stack, SvgIcon, useTheme } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { DragIndicator, MoreVert } from '@mui/icons-material';
import { MenuPopover } from 'src/components';
import { columnStyles } from '../../style';
import { useHtmlElement } from 'src/hooks/useHtmlElement';

const DraggableColumn: FunctionComponent<
  PropsWithChildren<{
    id: string | number;
    dragHandleProps?: React.HTMLAttributes<HTMLElement>;
    renderContextItems?: () => JSX.Element;
    disabled?: boolean;
  }>
> = ({ children, dragHandleProps, renderContextItems, disabled }) => {
  const theme = useTheme();
  const { htmlElement, addHtmlElement, removeHtmlElement } = useHtmlElement();

  return (
    <Stack
      sx={{ ...columnStyles(theme), ...(disabled ? { backgroundColor: '#F4F4F7' } : {}) }}
      spacing={1}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1} {...dragHandleProps}>
          <SvgIcon
            component={DragIndicator}
            sx={{
              color: 'text.disabled',
              cursor: dragHandleProps && Object.keys(dragHandleProps).length ? 'grab' : 'default',
            }}
          />
          {children}
        </Stack>

        {renderContextItems && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              addHtmlElement(e.currentTarget);
            }}
          >
            <SvgIcon sx={{ color: theme.palette.grey[500] }} component={MoreVert} />
          </IconButton>
        )}
      </Stack>

      {renderContextItems && (
        <MenuPopover onClose={removeHtmlElement} open={htmlElement} arrow="top-left">
          {renderContextItems()}
        </MenuPopover>
      )}
    </Stack>
  );
};

export default DraggableColumn;
